<template>
  <div class="form-container">
    <el-card class="form-card" style="max-width: 500px; min-width: 320px;">
      <h2>Reset Your Password</h2>
      <el-form @submit.prevent>
        <el-form-item>
          <el-input v-if="emailsent == false" type="email" placeholder="Email" prefix-icon="fas fa-at" v-model="form.email"></el-input>
        </el-form-item>
        <h1 v-if="this.loader == true" class="loader"></h1>
        <div v-if="emailsent">
          <h1 >We sent you an Email!</h1>
          <h3> Please allow up to a few minutes for the email to arrive, also please check in your promotions folder.</h3>
         </div>
        <el-button v-if="emailsent == false" type="primary" @click.native="resetPassword()" block>Reset My Password</el-button>
      </el-form>
    </el-card>
    <div class="alert-failure">
      <p class="alert-failure-p" v-if="validated">The email you entered is incorrect or empty.</p>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  data() {
    return {
      loader: false,

      form: {
        email: ""
      },
      emailsent: false,
      validated: false
    };
  },
  methods: {
    resetPassword() {
      this.loader = true;
      EventService.resetPassword(this.form).then(response => {
        if (response.status == 200) {
          this.emailsent = true;
          this.loader = false;
        } 
      })
        .catch(error => {
            console.log(error);
            this.loader = false;
        });

      if (this.form.email.length < 1) {
        this.validated = true;
          this.loader = false;

        setTimeout(() => {
          this.validated = false;
        }, 2000);
      } else {
        this.validated = false;
      }
    }
  }
};
</script>

<style scoped>
.alert-failure {
  margin-top: 40%;
  position: absolute;
  width: 380px;
  margin-left: 36.5%;
}
.alert-failure-p {
  background-color: red;
  color: seashell;
  padding: 6%;
  padding-right: 16%;
}
@media screen and (max-width: 600px) {
  .alert-failure {
    margin-top: 80%;
    width: 330px;
    margin-left: 0%;
  }
  .alert-failure-p {
    padding: 6%;
    padding-right: 6%;
  }
}
</style>